import React, { Component } from 'react'
import { Card } from 'react-bootstrap';

import '../Styles.css';

class ComprobanteGeneralInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">Folio Fiscal: </strong>
          { data.uuid }
          <br/>

          <strong className="text-info card-label-info">Emisor: </strong>
          { data.emisor_rfc } { data.emisor_razon_social || '' }
          <br/>

          <strong className="text-info card-label-info">Receptor: </strong>
          { data.receptor_rfc } { data.receptor_razon_social || '' }
          <br/>

          { !!data.serie && (
              <span>
                <strong className="text-info card-label-info">Serie/Folio: </strong>
                { data.serie + '/' + data.folio }
                <br/>
              </span>
            )
          }

          <strong className="text-info card-label-info">Total: </strong>
          { data.total }
          <br/>
        </Card.Body>
      </Card>
    )
  }
}

export default ComprobanteGeneralInfo;